import { exprEvaluate } from "helpers/ExprEval";
import _ from "lodash";

export const REPORT = {
  AB_TESTING: "ab-testing",
  CODE_SNIPPET: "code-snippet",
};

export const DATAVIEW = {
  PROCESSED: "Processed Reports",
  SOURCE: "Source Data",
};

export const PROCESSED_REPORTS = {
  [REPORT.AB_TESTING]: {
    REPORT_1: "request_score_report",
    REPORT_2: "general_performance_report",
    REPORT_3: "general_request_report",
    REPORT_4: "general_ad_report",
    REPORT_5: "serving_restriction_request_report",
    REPORT_6: "predicted_viewability_report",
    REPORT_7: "active_view_and_ctr_report",
    REPORT_8: "prebid_request_report",
  },
  [REPORT.CODE_SNIPPET]: {
    REPORT_1: "request_score_report",
    REPORT_2: "inventory_registry_report",
    REPORT_3: "signal_augmentation_position_report",
    REPORT_4: "signal_augmentation_user_behavior_report",
    REPORT_5: "traffic_allocation_report",
    REPORT_6: "code_snippet_build_request_report",
  },
};

export function parseTableData({
  records,
  columns,
  arrangeColumns,
  mainKey,
  subKey = "",
  orderKey = "",
}) {
  const mainIdx = _.indexOf(columns, mainKey);
  const subIdx = subKey !== "" ? _.indexOf(columns, subKey) : -1;
  const orderIdx = orderKey !== "" ? _.indexOf(columns, orderKey) : -1;

  const byMain = _.groupBy(records, (item) => item[mainIdx]);
  const tempOrder =
    orderIdx >= 0
      ? _.orderBy(
          _.values(byMain),
          (list) => _.sum(list.map((item) => _.toNumber(item[orderIdx]))),
          "desc"
        )
      : _.values(byMain);
  const order = tempOrder.map((mlist) => {
    if (subIdx >= 0) {
      const bySub = _.groupBy(mlist, (item) => item[subIdx]);
      const subOrder =
        orderIdx >= 0
          ? _.values(bySub).map((list) =>
              _.orderBy(list, (item) => item[orderIdx], "desc")
            )
          : _.values(bySub);
      return _.map(subOrder, (sList) => {
        return _.map(sList, (item) => {
          return parseToObject(item, arrangeColumns, columns);
        });
      });
    }
    return _.map(mlist, (item) => {
      return parseToObject(item, arrangeColumns, columns);
    });
  });

  const subGroup =
    subIdx >= 0
      ? _.map(order, (listById) => {
          return _.map(listById, (list) => {
            return parseToGroupObject(list, arrangeColumns, true);
          });
        })
      : [];

  const mainGroup = _.map(subIdx >= 0 ? subGroup : order, (list) => {
    return parseToGroupObject(list, arrangeColumns);
  });

  const amount = parseToGroupObject(_.flattenDeep(order), arrangeColumns);

  return {
    records: order,
    groups: [mainGroup, subGroup],
    amount,
  };
}

function parseToObject(data, arrange, indexs) {
  const sortByParse = _.orderBy(arrange, (col) => (col.parsefunc ? 1 : 0));

  return sortByParse.reduce((obj, col) => {
    let value = null;
    if (col.parsefunc) {
      value = col.parsefunc(obj);
    } else {
      const index = _.indexOf(indexs, col.key);
      value = data[index] === undefined ? "-" : data[index];
    }

    return {
      ...obj,
      [col.key]: value,
    };
  }, {});
}

export function parseToGroupObject(data, arrange, isSubGroup = false) {
  const sortByParse = _.orderBy(arrange, (col) => (col.parsefunc ? 1 : 0));

  return sortByParse.reduce(
    (obj, col) => {
      let value = "";
      if (
        col.groupfunc ||
        col.groupDatafunc ||
        (isSubGroup && col.subGroupfunc)
      ) {
        const key = col.dataKey || col.key;
        if (col.groupDatafunc) {
          value = col.groupDatafunc(data, key);
        } else {
          const keyList = _.map(data, (item) => item[key]);
          if (isSubGroup && col.subGroupfunc) {
            value = col.subGroupfunc(keyList);
          } else if (col.groupfunc) {
            value = col.groupfunc(keyList);
          }
        }
      } else if (col.parsefunc) {
        value = col.parsefunc(obj);
      }

      return {
        ...obj,
        [col.key]: value,
      };
    },
    { count: data.length }
  );
}

export function filterDataToGroup({
  expression,
  records,
  columns,
  hasSubGroup = false,
}) {
  const filteredRecords = filterRecords({ expression, records });

  return filterGroupResult({
    records: filteredRecords || [],
    columns,
    hasSubGroup,
  });
}

function filterRecords({ expression, records }) {
  if (expression === "") {
    return records;
  }

  try {
    function evalArray(arr) {
      if (_.isArray(arr[0])) {
        return arr.map((item) => {
          return evalArray(item);
        });
      }
      return arr.filter((item) => {
        return exprEvaluate(expression, item);
      });
    }

    function removeEmptyArrays(input) {
      if (!_.isArray(input)) return input;

      const cleaned = input.map(removeEmptyArrays).filter((item) => {
        if (!_.isArray(item)) return true;
        return item.length > 0;
      });

      return cleaned;
    }

    const evalResult = evalArray(records);

    return removeEmptyArrays(evalResult);
  } catch (err) {
    return null;
  }
}

function filterGroupResult({ records, columns, hasSubGroup = false }) {
  const subGroup = hasSubGroup
    ? _.map(records, (listById) => {
        return _.map(listById, (list) => {
          return parseToGroupObject(list, columns, true);
        });
      })
    : [];

  const mainGroup = _.map(hasSubGroup ? subGroup : records, (list) => {
    return parseToGroupObject(list, columns);
  });

  const amount = parseToGroupObject(_.flattenDeep(records), columns);

  return {
    filterGroups: [mainGroup, subGroup],
    filterRecords: records,
    filterAmount: amount,
  };
}
